/*
 * @Author:Teemo Ding
 * @Date: 2021-04-21 14:19:03
 * @LastEditTime: 2021-06-22 10:44:27
 * @LastEditors: Teemo Ding
 * @Description:Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/ListPage/Alias/DuplicateModal.tsx
 */

import React from 'react';

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import InputItem from '@/src/components/InputItem/InputItem';
import Row from '@/src/components/Layouts/Row/Row';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
interface IProps {
  setShowModal: (value: boolean) => void;
  defaultName: string;
  nameList: string[];
  handleDuplicate: (value: string) => void;
}

const DuplicateModal = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setShowModal, defaultName, nameList, handleDuplicate } = props;

  const [inputErr, setInputErr] = React.useState(false);
  const [value, setValue] = React.useState(defaultName);
  const [help, setHelp] = React.useState('');
  const handleClickCancel = () => {
    setShowModal(false);
  };

  const handleOnSubmit = () => {
    if (!value || value.match(/^\s*$/)) {
      setInputErr(true);
      setHelp('');
      return;
    }
    if (nameList.includes(value)) {
      setInputErr(true);
      setHelp(getI18n('salesChannelProductAlias.listPage.setHelpText'));
      return;
    }
    handleDuplicate(value);
  };

  return (
    <div>
      <Row
        elements={[
          {
            child: (
              <InputItem
                value={value}
                setValue={setValue}
                maxLength={100}
                title={getI18n('general.name')}
                help={help}
                setErr={setInputErr}
                err={inputErr}
              />
            ),
          },
        ]}
      />
      <ModalFooter
        onCancel={handleClickCancel}
        okText={getI18n('general.duplicate')}
        onOk={handleOnSubmit}
      />
    </div>
  );
};
export default DuplicateModal;
